import {
	ORG_INFO_SESSION_STORAGE,
	USER_INFO_SESSION_STORAGE,
} from 'src/helpers/constant';

export const initializePendo = () => {
	const userOrg = JSON.parse(sessionStorage.getItem(ORG_INFO_SESSION_STORAGE));
	const userInfo = JSON.parse(
		sessionStorage.getItem(USER_INFO_SESSION_STORAGE)
	);
	if (typeof pendo === 'object') {
		//eslint-disable-next-line no-undef
		pendo.initialize({
			visitor: {
				id: userInfo?.id,
			},
			account: {
				id: userOrg?.clientId,
				name: userOrg?.name,
			},
		});
	}
};
